import { Component } from '@angular/core';

@Component({
  selector: 'app-header-mini',
  templateUrl: './header-mini.component.html',
  styleUrls: ['./header-mini.component.scss'],
})
export class HeaderMiniComponent {
  constructor() {}
}
